module.exports = __webpack_public_path__ + "img/pos_banner_bg.4a789919.jpg";